import { IModule } from '../globals';

class Billboard implements IModule {
	element: HTMLElement;
	slot: HTMLElement | null;
	placeholder: HTMLElement | null;
	observer: MutationObserver | null = null;

	constructor(element: HTMLElement) {
		this.element = element;
		this.slot = element.querySelector('.js-slot');
		this.placeholder = element.querySelector('.js-placeholder');

		this.initialize();
	}

	initialize() {
		if (this.slot) {
			this.observeSlotChanges();
		}
	}

	observeSlotChanges() {
		if (!this.slot || !this.placeholder) return;

		this.observer = new MutationObserver(() => {
			if (this.slot!.childNodes.length > 0) {
				this.placeholder?.remove();
				this.observer?.disconnect();
			}
		});

		this.observer.observe(this.slot, { childList: true, subtree: true });
	}
}

export default Billboard;
